export default "/kiban/_next/static/images/board-92c2ca835ef86e326e2c756248f2a061.png";